
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("d2S0J", function(module, exports) {
$parcel$export(module.exports, "getGlobalErrorCount", () => $e684ec8d641ebf7b$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $e684ec8d641ebf7b$export$2e2bcd8739ae039);

var $4eDgu = parcelRequire("4eDgu");
let $e684ec8d641ebf7b$var$shouldInitilizeGlobalErrorHandler = true;
let $e684ec8d641ebf7b$var$globalCount = 0;
const $e684ec8d641ebf7b$var$errors = [];
let $e684ec8d641ebf7b$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $e684ec8d641ebf7b$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $e684ec8d641ebf7b$export$ebe081a8c9bf8176(sinkFunc) {
    $e684ec8d641ebf7b$var$push = sinkFunc;
    $e684ec8d641ebf7b$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $e684ec8d641ebf7b$var$errors.length = 0;
}
function $e684ec8d641ebf7b$export$d06c0426664e7c08() {
    return $e684ec8d641ebf7b$var$globalCount;
}
function $e684ec8d641ebf7b$var$handleError(e) {
    $e684ec8d641ebf7b$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $e684ec8d641ebf7b$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $e684ec8d641ebf7b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $e684ec8d641ebf7b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch  {}
}
function $e684ec8d641ebf7b$var$handlePromiseRejection(e) {
    $e684ec8d641ebf7b$var$globalCount++;
    if (e.reason instanceof Error) $e684ec8d641ebf7b$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $e684ec8d641ebf7b$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch  {}
}
function $e684ec8d641ebf7b$var$setupUFOGlobalErrorHandler() {
    if ($e684ec8d641ebf7b$var$shouldInitilizeGlobalErrorHandler) {
        (0, $4eDgu.bind)(window, {
            type: 'error',
            listener: (e)=>$e684ec8d641ebf7b$var$handleError(e)
        });
        (0, $4eDgu.bind)(window, {
            type: 'unhandledrejection',
            listener: $e684ec8d641ebf7b$var$handlePromiseRejection
        });
        $e684ec8d641ebf7b$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $e684ec8d641ebf7b$export$2e2bcd8739ae039 = $e684ec8d641ebf7b$var$setupUFOGlobalErrorHandler;

});

parcelRegister("hGtke", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $dbaf7d161e6f3b6b$export$b33b857ad1d9900e);
$parcel$export(module.exports, "installErrorHandler", () => $dbaf7d161e6f3b6b$export$abd5747ea77ecab9);

var $eGOwo = parcelRequire("eGOwo");
const $dbaf7d161e6f3b6b$var$buffer = [];
let $dbaf7d161e6f3b6b$var$push = (payload)=>{
    $dbaf7d161e6f3b6b$var$buffer.push(payload);
};
function $dbaf7d161e6f3b6b$export$b33b857ad1d9900e(payload) {
    $dbaf7d161e6f3b6b$var$push(payload);
}
function $dbaf7d161e6f3b6b$export$abd5747ea77ecab9(handler) {
    if ((0, $eGOwo.fg)('moving_jira_entry-points_api_under_platform')) {
        $dbaf7d161e6f3b6b$var$push = handler;
        $dbaf7d161e6f3b6b$var$buffer.forEach((payload)=>handler(payload));
        $dbaf7d161e6f3b6b$var$buffer.length = 0;
    }
}

});

parcelRegister("7aoMz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea70cd4dcdbd551a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $ea70cd4dcdbd551a$export$11bcb6e9af2aca35);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");
var $ea70cd4dcdbd551a$export$2e2bcd8739ae039 = (0, $d0Gew.default);
function $ea70cd4dcdbd551a$export$11bcb6e9af2aca35() {
    return (0, $eJOHy.useContext)((0, $d0Gew.default));
}

});

parcelRegister("k04JP", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $ffaf3bb0a526b006$export$c08e7affcf78b064);

var $3yxn4 = parcelRequire("3yxn4");

var $aYXC1 = parcelRequire("aYXC1");

var $gIaDh = parcelRequire("gIaDh");

var $ehk4p = parcelRequire("ehk4p");

var $1GZSt = parcelRequire("1GZSt");

var $7iYeO = parcelRequire("7iYeO");

var $1bqgN = parcelRequire("1bqgN");

var $cXQfL = parcelRequire("cXQfL");
const $ffaf3bb0a526b006$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $ehk4p.visibilityChangeObserver).start();
            if (config.events[(0, $cXQfL.BMEventsType).WEB_VITALS]?.enabled) (0, $1GZSt.webVitalsObserver).start();
            if (config.debug) {
                (0, $aYXC1.logger).enable();
                (0, $1bqgN.submitter).setDebug(true);
                (0, $gIaDh.pageLoadMetaMetric).setDebug(true);
            }
            (0, $1bqgN.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $3yxn4.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $7iYeO.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $gIaDh.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $gIaDh.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $gIaDh.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $gIaDh.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $gIaDh.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $gIaDh.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $ffaf3bb0a526b006$export$c08e7affcf78b064 = $ffaf3bb0a526b006$var$makeBrowserMetrics();

});
parcelRegister("3yxn4", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $2cb1bcf3bf1ddd66$export$9e87a201397ac0a9);
const $2cb1bcf3bf1ddd66$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $2cb1bcf3bf1ddd66$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("aYXC1", function(module, exports) {
$parcel$export(module.exports, "logger", () => $4affcc00f45d0af3$export$af88d00dbe7f521);
const $4affcc00f45d0af3$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("gIaDh", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $8f5be7860521316c$export$24b7a1a311eb05dc);

var $cXQfL = parcelRequire("cXQfL");

var $4nAvL = parcelRequire("4nAvL");

var $coO5R = parcelRequire("coO5R");
class $8f5be7860521316c$export$9609608c00ea5077 extends (0, $coO5R.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $4nAvL.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $8f5be7860521316c$export$24b7a1a311eb05dc = new $8f5be7860521316c$export$9609608c00ea5077({
    type: (0, $cXQfL.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("cXQfL", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $e66c9d437c81bea7$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $e66c9d437c81bea7$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $e66c9d437c81bea7$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $e66c9d437c81bea7$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $e66c9d437c81bea7$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $e66c9d437c81bea7$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $e66c9d437c81bea7$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $e66c9d437c81bea7$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $e66c9d437c81bea7$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $e66c9d437c81bea7$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $e66c9d437c81bea7$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $e66c9d437c81bea7$export$60c0193054fc3040);

var $4nAvL = parcelRequire("4nAvL");
var $e66c9d437c81bea7$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $e66c9d437c81bea7$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $e66c9d437c81bea7$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $e66c9d437c81bea7$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $e66c9d437c81bea7$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $e66c9d437c81bea7$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $e66c9d437c81bea7$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $e66c9d437c81bea7$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $e66c9d437c81bea7$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $e66c9d437c81bea7$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $e66c9d437c81bea7$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $e66c9d437c81bea7$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $e66c9d437c81bea7$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("4nAvL", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $b38b22ad3b6888be$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $b38b22ad3b6888be$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $b38b22ad3b6888be$export$2bce4ffdd840e878);

var $2UHkt = parcelRequire("2UHkt");

var $aYXC1 = parcelRequire("aYXC1");

var $ehk4p = parcelRequire("ehk4p");

var $bKvF5 = parcelRequire("bKvF5");
var $b38b22ad3b6888be$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $b38b22ad3b6888be$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $b38b22ad3b6888be$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $b38b22ad3b6888be$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $b38b22ad3b6888be$var$getPageVisibleState();
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $2UHkt.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $aYXC1.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $b38b22ad3b6888be$var$getPageVisibleState();
        (0, $ehk4p.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $aYXC1.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $aYXC1.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $ehk4p.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $aYXC1.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $ehk4p.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $b38b22ad3b6888be$export$2bce4ffdd840e878 ? (0, $bKvF5.UntilExperience).fromMetric(metricOrConfig) : (0, $bKvF5.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $b38b22ad3b6888be$var$getPageVisibleState();
    }
}

});
parcelRegister("2UHkt", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $3511099d49f90d0d$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $3511099d49f90d0d$export$df21d285cfcda81e);
const $3511099d49f90d0d$export$1d17377365286b00 = [
    'ssr'
];
const $3511099d49f90d0d$export$df21d285cfcda81e = 7500;

});

parcelRegister("ehk4p", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $095c86a7c5735399$export$13e680397ec8f3eb);
class $095c86a7c5735399$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $095c86a7c5735399$export$13e680397ec8f3eb = new $095c86a7c5735399$var$VisibilityChangeObserver();

});

parcelRegister("bKvF5", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $64e38b5a1e953e12$export$3fcc0936ee2cc852);
class $64e38b5a1e953e12$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $64e38b5a1e953e12$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $64e38b5a1e953e12$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$64e38b5a1e953e12$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$64e38b5a1e953e12$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("coO5R", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $fabc969f86ec0ac9$export$fd1447b187f590fe);

var $aYXC1 = parcelRequire("aYXC1");

var $4nAvL = parcelRequire("4nAvL");
class $fabc969f86ec0ac9$export$fd1447b187f590fe extends (0, $4nAvL.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $aYXC1.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $4nAvL.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $aYXC1.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $aYXC1.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $4nAvL.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $fabc969f86ec0ac9$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $fabc969f86ec0ac9$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($fabc969f86ec0ac9$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("1GZSt", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $4a849f50c08840cb$export$253d38dccbb37615);


class $4a849f50c08840cb$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("1bxZm"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("aENBy"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $4a849f50c08840cb$export$253d38dccbb37615 = new $4a849f50c08840cb$var$WebVitalsObserver();

});
parcelRegister("1bxZm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cE1ja").then(()=>parcelRequire('6CpHo'));

});
parcelRegister("ewTvA", function(module, exports) {
"use strict";

function $a93f1ca862af756d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("iTG8W")).resolve(id));
}
module.exports = $a93f1ca862af756d$var$load;

});
parcelRegister("iTG8W", function(module, exports) {
$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});



parcelRegister("aENBy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9eSLL").then(()=>parcelRequire('esyh1'));

});


parcelRegister("7iYeO", function(module, exports) {
$parcel$export(module.exports, "Route", () => $4be040fb07a0ee4c$export$e7b0ac011bb776c6);
const $4be040fb07a0ee4c$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("1bqgN", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $4e632be5a165d727$export$c21a25872e3f5a2b);

var $2QO3b = parcelRequire("2QO3b");

var $cXQfL = parcelRequire("cXQfL");

var $hpoy3 = parcelRequire("hpoy3");

var $ktxgI = parcelRequire("ktxgI");
const $4e632be5a165d727$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $ktxgI.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $cXQfL.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $2QO3b.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $hpoy3.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("hpoy3", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $1276769c1de27cca$export$896b6e121bbaec25);

var $2UHkt = parcelRequire("2UHkt");

var $aYXC1 = parcelRequire("aYXC1");

var $gC2sA = parcelRequire("gC2sA");

var $6tQ64 = parcelRequire("6tQ64");

var $74PQl = parcelRequire("74PQl");

var $la6yF = parcelRequire("la6yF");

var $lNwzH = parcelRequire("lNwzH");

var $3P9D2 = parcelRequire("3P9D2");

var $277OL = parcelRequire("277OL");

var $hwBRd = parcelRequire("hwBRd");

var $2zoEL = parcelRequire("2zoEL");

var $giswk = parcelRequire("giswk");

var $chzKK = parcelRequire("chzKK");

var $eVjVF = parcelRequire("eVjVF");

var $9Nc2I = parcelRequire("9Nc2I");

var $fvlyV = parcelRequire("fvlyV");

var $5b4TN = parcelRequire("5b4TN");

var $gD7ut = parcelRequire("gD7ut");

var $7z18k = parcelRequire("7z18k");

var $bEMVP = parcelRequire("bEMVP");

var $fMpGh = parcelRequire("fMpGh");

var $fpkgy = parcelRequire("fpkgy");

var $lrlia = parcelRequire("lrlia");

var $9ufXM = parcelRequire("9ufXM");

var $4vlQH = parcelRequire("4vlQH");

var $5i7cP = parcelRequire("5i7cP");

var $dnCpp = parcelRequire("dnCpp");

var $dq68t = parcelRequire("dq68t");

var $f6Txi = parcelRequire("f6Txi");

var $8VA3X = parcelRequire("8VA3X");

var $4KAfX = parcelRequire("4KAfX");

var $igcFI = parcelRequire("igcFI");

var $eOR3p = parcelRequire("eOR3p");

var $lNWXm = parcelRequire("lNWXm");

var $hjZkb = parcelRequire("hjZkb");

var $70pgj = parcelRequire("70pgj");

var $cXQfL = parcelRequire("cXQfL");
const $1276769c1de27cca$var$defaultSet = [
    (0, $hwBRd.eventKey),
    (0, $9Nc2I.eventType),
    (0, $giswk.eventProduct),
    (0, $eVjVF.eventRoute),
    (0, $3P9D2.eventId),
    (0, $2zoEL.eventLocalTime),
    (0, $chzKK.eventRegion),
    (0, $6tQ64.appFramework),
    (0, $74PQl.appVersion),
    (0, $la6yF.bmVersion),
    (0, $8VA3X.telemetryBrowser),
    (0, $4KAfX.telemetryCpu),
    (0, $igcFI.telemetryMemory),
    (0, $eOR3p.telemetryNetwork),
    (0, $lNwzH.customData),
    (0, $fvlyV.featureFlags),
    (0, $5b4TN.hostname),
    (0, $dnCpp.productCustomData),
    (0, $lNWXm.appTimings),
    (0, $70pgj.resourceTimings)
];
const $1276769c1de27cca$var$pageLoadCommon = [
    ...$1276769c1de27cca$var$defaultSet,
    (0, $4vlQH.pageVisibleState),
    (0, $5i7cP.pageVisibleValue),
    (0, $277OL.eventInitial),
    (0, $fpkgy.pageLoadMetrics),
    (0, $hjZkb.bundleEvalTimings)
];
const $1276769c1de27cca$var$initialPageLoadSet = [
    ...$1276769c1de27cca$var$pageLoadCommon,
    (0, $7z18k.initialPageLoadMetrics),
    (0, $fMpGh.navigationMetrics),
    (0, $f6Txi.ssrSuccess),
    (0, $dq68t.ssrFeatureFlags)
];
const $1276769c1de27cca$var$spaTransitionSet = [
    ...$1276769c1de27cca$var$pageLoadCommon
];
const $1276769c1de27cca$var$pageSegmentLoadSet = [
    ...$1276769c1de27cca$var$defaultSet,
    (0, $lrlia.pageSegmentLoadMetrics),
    (0, $4vlQH.pageVisibleState),
    (0, $5i7cP.pageVisibleValue),
    (0, $277OL.eventInitial),
    (0, $hjZkb.bundleEvalTimings)
];
const $1276769c1de27cca$var$interactionSet = [
    ...$1276769c1de27cca$var$defaultSet,
    (0, $4vlQH.pageVisibleState),
    (0, $5i7cP.pageVisibleValue),
    (0, $bEMVP.interactionMetrics)
];
const $1276769c1de27cca$var$customMetricSet = [
    ...$1276769c1de27cca$var$defaultSet,
    (0, $4vlQH.pageVisibleState),
    (0, $5i7cP.pageVisibleValue),
    (0, $gD7ut.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $1276769c1de27cca$var$webVitalsMetricSet = [
    ...$1276769c1de27cca$var$defaultSet,
    (0, $9ufXM.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $1276769c1de27cca$var$waitForCLS = (delay = (0, $2UHkt.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $1276769c1de27cca$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $aYXC1.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $cXQfL.BMEventsType).PAGE_LOAD && (0, $gC2sA.isPageLoadMetricData)(data) && data.isInitial) set = $1276769c1de27cca$var$initialPageLoadSet;
    if (data.config.type === (0, $cXQfL.BMEventsType).PAGE_LOAD && (0, $gC2sA.isPageLoadMetricData)(data) && !data.isInitial) set = $1276769c1de27cca$var$spaTransitionSet;
    if (data.config.type === (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD && (0, $gC2sA.isPageSegmentLoadMetricData)(data)) set = $1276769c1de27cca$var$pageSegmentLoadSet;
    if (data.config.type === (0, $cXQfL.BMEventsType).INLINE_RESULT) set = $1276769c1de27cca$var$interactionSet;
    if (data.config.type === (0, $cXQfL.BMEventsType).CUSTOM) set = $1276769c1de27cca$var$customMetricSet;
    if (data.config.type === (0, $cXQfL.BMEventsType).WEB_VITALS) {
        set = $1276769c1de27cca$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $1276769c1de27cca$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("gC2sA", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $7d7157ad4208a89a$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $7d7157ad4208a89a$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $7d7157ad4208a89a$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $7d7157ad4208a89a$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $7d7157ad4208a89a$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $7d7157ad4208a89a$export$b493eb8b2ba87421);

var $cXQfL = parcelRequire("cXQfL");
const $7d7157ad4208a89a$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $cXQfL.BMEventsType).PAGE_LOAD;
};
const $7d7157ad4208a89a$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $7d7157ad4208a89a$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $cXQfL.BMEventsType).PAGE_LOAD;
};
const $7d7157ad4208a89a$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $7d7157ad4208a89a$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $cXQfL.BMEventsType).INLINE_RESULT;
};
const $7d7157ad4208a89a$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $cXQfL.BMEventsType).CUSTOM;
};

});

parcelRegister("6tQ64", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $69bb45ae0da81712$export$e34e4529b979f74c);
const $69bb45ae0da81712$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("74PQl", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $3aca22f4ea111254$export$82ae485178b37419);
const $3aca22f4ea111254$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("la6yF", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $0da7b8fb4ab1f55e$export$5cafa465fc876895);
const $0da7b8fb4ab1f55e$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("lNwzH", function(module, exports) {
$parcel$export(module.exports, "customData", () => $3a85ea38b92e5fa9$export$f7e743c7db162193);
const $3a85ea38b92e5fa9$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("3P9D2", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $becb22dee011ec75$export$aed28df7ac07d79a);
const $becb22dee011ec75$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("277OL", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $f89d7db464534f3b$export$fa8e91d436b3ef8b);

var $gC2sA = parcelRequire("gC2sA");
const $f89d7db464534f3b$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $gC2sA.isPageLoadMetricData)(data) && !(0, $gC2sA.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("hwBRd", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $af4789c55382c67e$export$10be2d3a558d3f88);

var $975Ph = parcelRequire("975Ph");
const $af4789c55382c67e$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $975Ph.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("975Ph", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $dc0d090414f8ca3a$export$b334d07f11140768);

var $cXQfL = parcelRequire("cXQfL");
const $dc0d090414f8ca3a$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $cXQfL.BMEventsType).CUSTOM:
            return (0, $cXQfL.StorableBMEventsType).CUSTOM;
        case (0, $cXQfL.BMEventsType).INLINE_RESULT:
            return (0, $cXQfL.StorableBMEventsType).INLINE_RESULT;
        case (0, $cXQfL.BMEventsType).PAGE_LOAD:
            return (0, $cXQfL.StorableBMEventsType).PAGE_LOAD;
        case (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $cXQfL.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $cXQfL.BMEventsType).WEB_VITALS:
            return (0, $cXQfL.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("2zoEL", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $32e0a8711b462977$export$5219854ae7ec45da);

var $57raR = parcelRequire("57raR");
const $32e0a8711b462977$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $57raR.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $57raR.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("giswk", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $03cc20c0b73da81c$export$a7df4e8088db8843);
const $03cc20c0b73da81c$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("chzKK", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $84139f45cf989ab3$export$d0117b71adcdebc0);
const $84139f45cf989ab3$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("eVjVF", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $fa2d75d06fb81eb7$export$44d3627af289ca16);
const $fa2d75d06fb81eb7$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("9Nc2I", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $1d635a86f4b9e5ce$export$4c045e605d532c98);

var $975Ph = parcelRequire("975Ph");
const $1d635a86f4b9e5ce$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $975Ph.mapEventType)(config.type)
    };
};

});

parcelRegister("fvlyV", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $0436372dae4f867c$export$e62953d023125748);
const $0436372dae4f867c$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("5b4TN", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $f6632121db4dba0e$export$640106f6dc7d2706);
const $f6632121db4dba0e$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("gD7ut", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $80c6e4785ab42e6b$export$cab039265c52a2e9);

var $gC2sA = parcelRequire("gC2sA");
const $80c6e4785ab42e6b$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $gC2sA.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("7z18k", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $5e898143a36c967d$export$cc95aa3f6ea8e5cb);
const $5e898143a36c967d$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("bEMVP", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $20e7020e656c3a5d$export$86db56030b57ba34);

var $gC2sA = parcelRequire("gC2sA");

var $cXQfL = parcelRequire("cXQfL");
const $20e7020e656c3a5d$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $gC2sA.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $cXQfL.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $cXQfL.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $cXQfL.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $cXQfL.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $cXQfL.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("fMpGh", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $37c95b8f8d112479$export$b88d990436be0f8a);
const $37c95b8f8d112479$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("fpkgy", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $47e12cd3977827ac$export$2878bf482e539059);

var $gC2sA = parcelRequire("gC2sA");

var $cXQfL = parcelRequire("cXQfL");
const $47e12cd3977827ac$var$getThreshold = (isInitial, metric)=>{
    return (0, $cXQfL.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $47e12cd3977827ac$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $47e12cd3977827ac$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $gC2sA.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $cXQfL.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $47e12cd3977827ac$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $47e12cd3977827ac$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $47e12cd3977827ac$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $47e12cd3977827ac$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $47e12cd3977827ac$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $47e12cd3977827ac$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("lrlia", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $775da330aee63142$export$ba86cb47f2f22db5);

var $gIaDh = parcelRequire("gIaDh");

var $gC2sA = parcelRequire("gC2sA");

var $cXQfL = parcelRequire("cXQfL");
const $775da330aee63142$var$getThreshold = (isInitial, metric)=>{
    return (0, $cXQfL.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $775da330aee63142$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $775da330aee63142$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $gC2sA.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $cXQfL.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $775da330aee63142$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $775da330aee63142$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $775da330aee63142$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $775da330aee63142$var$getHistogram(data.isInitial, (0, $cXQfL.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $775da330aee63142$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $775da330aee63142$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $cXQfL.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $cXQfL.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $gIaDh.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $cXQfL.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("9ufXM", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $ee63137aef2e5263$export$3731db279f590f30);

var $4nAvL = parcelRequire("4nAvL");

var $ehk4p = parcelRequire("ehk4p");

var $1GZSt = parcelRequire("1GZSt");

var $5i7cP = parcelRequire("5i7cP");
const $ee63137aef2e5263$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $4nAvL.PageVisibleState).MIXED;
    };
    (0, $ehk4p.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $ee63137aef2e5263$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $ehk4p.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $5i7cP.pageVisibleValue)(config, data, globalConfig)
    };
};
const $ee63137aef2e5263$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $1GZSt.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $1GZSt.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $1GZSt.webVitalsObserver).data;
};

});
parcelRegister("5i7cP", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $f769814833fe4424$export$177b923114656380);

var $4nAvL = parcelRequire("4nAvL");
var $cXQfL = parcelRequire("cXQfL");
const $f769814833fe4424$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $cXQfL.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $4nAvL.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("4vlQH", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $d8800af18115e612$export$723b4c298aca63af);
const $d8800af18115e612$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("dnCpp", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $3d2fbd81f8d2e2eb$export$fa2af6e412815a74);
const $3d2fbd81f8d2e2eb$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("dq68t", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $9d6b10ab97e15efb$export$fdbea518c19dfa8);

var $cXQfL = parcelRequire("cXQfL");
const $9d6b10ab97e15efb$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $9d6b10ab97e15efb$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $cXQfL.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $cXQfL.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $cXQfL.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $9d6b10ab97e15efb$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("f6Txi", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $80bed992d133e477$export$a3dc8251cf55b2e0);
const $80bed992d133e477$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("8VA3X", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $89d3e063d519fbd7$export$386b10ac64a50b1);

var $3nEAz = parcelRequire("3nEAz");
const $89d3e063d519fbd7$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("4KAfX", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $1df861258673f70e$export$9f84cb359ed29139);
const $1df861258673f70e$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("igcFI", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $6bd41a4fccbd6850$export$496c14d72b257e07);
const $6bd41a4fccbd6850$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("eOR3p", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $2563d8a82f9eb0d7$export$88bf7b55f7fc4e8e);
const $2563d8a82f9eb0d7$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("lNWXm", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $a1e76296353cd052$export$e952f50a4f2d02da);

var $cXQfL = parcelRequire("cXQfL");

var $60kwI = parcelRequire("60kwI");

var $6TEx9 = parcelRequire("6TEx9");
const $a1e76296353cd052$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $cXQfL.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $60kwI.customTimings)(config, data);
    const ssr = config.type === (0, $cXQfL.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $6TEx9.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("60kwI", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $5552dbec91da0467$export$6126f85083a72c6e);

const $5552dbec91da0467$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $5552dbec91da0467$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $5552dbec91da0467$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $5552dbec91da0467$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $3e9c0e1856c1af11$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $3e9c0e1856c1af11$export$b98e411ae80c806f = '/';


parcelRegister("6TEx9", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $4c72ce3381fa9e8a$export$130f411261a599c5);

const $4c72ce3381fa9e8a$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $4c72ce3381fa9e8a$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $4c72ce3381fa9e8a$var$SSR_PREFIX = 'ssr';
const $4c72ce3381fa9e8a$var$mapKey = (key)=>{
    if (key === 'total') return $4c72ce3381fa9e8a$var$SSR_PREFIX;
    return `${$4c72ce3381fa9e8a$var$SSR_PREFIX}${0, $3e9c0e1856c1af11$export$b98e411ae80c806f}${key}`;
};
const $4c72ce3381fa9e8a$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($4c72ce3381fa9e8a$var$filterEntry(entry[1])) acc[$4c72ce3381fa9e8a$var$mapKey(entry[0])] = $4c72ce3381fa9e8a$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("hjZkb", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $5aececbbef1030e4$export$1a2bb347935fc536);
const $5aececbbef1030e4$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $5aececbbef1030e4$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($5aececbbef1030e4$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("70pgj", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $08286d9ec22dba35$export$81a7d52441a06b50);
const $08286d9ec22dba35$var$cacheableTypes = [
    'script',
    'link'
];
const $08286d9ec22dba35$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $08286d9ec22dba35$var$CACHE_NETWORK = 'network';
const $08286d9ec22dba35$var$CACHE_MEMORY = 'memory';
const $08286d9ec22dba35$var$CACHE_DISK = 'disk';
const $08286d9ec22dba35$var$calculateTransferType = (type, duration, size)=>{
    if (!$08286d9ec22dba35$var$cacheableTypes.includes(type)) return $08286d9ec22dba35$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $08286d9ec22dba35$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $08286d9ec22dba35$var$CACHE_DISK;
    if (size === undefined) return null;
    return $08286d9ec22dba35$var$CACHE_NETWORK;
};
const $08286d9ec22dba35$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$08286d9ec22dba35$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $08286d9ec22dba35$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $08286d9ec22dba35$var$withoutHeaders = ()=>false;
const $08286d9ec22dba35$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $08286d9ec22dba35$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $08286d9ec22dba35$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $08286d9ec22dba35$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $08286d9ec22dba35$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $08286d9ec22dba35$var$getNetworkData = (item, eventStart, hasTimingHeaders = $08286d9ec22dba35$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$08286d9ec22dba35$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($08286d9ec22dba35$var$cacheableTypes.includes(type)) {
        const transferType = $08286d9ec22dba35$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$08286d9ec22dba35$var$getSizeObject(size)
        };
        if (transferType !== $08286d9ec22dba35$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$08286d9ec22dba35$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$08286d9ec22dba35$var$getSizeObject(size)
    };
};
const $08286d9ec22dba35$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $08286d9ec22dba35$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $08286d9ec22dba35$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$08286d9ec22dba35$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$08286d9ec22dba35$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("ktxgI", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $b7d0a7f7e241bd85$export$5b4fb14409a2a825);

var $cXQfL = parcelRequire("cXQfL");
const $b7d0a7f7e241bd85$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $b7d0a7f7e241bd85$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $cXQfL.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($b7d0a7f7e241bd85$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $b7d0a7f7e241bd85$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $cXQfL.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $cXQfL.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $cXQfL.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $cXQfL.BMEventsType).PAGE_LOAD]: $b7d0a7f7e241bd85$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $cXQfL.BMEventsType).PAGE_LOAD]),
        [(0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD]: $b7d0a7f7e241bd85$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $cXQfL.BMEventsType).INLINE_RESULT]: $b7d0a7f7e241bd85$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $cXQfL.BMEventsType).INLINE_RESULT]),
        [(0, $cXQfL.BMEventsType).CUSTOM]: $b7d0a7f7e241bd85$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $cXQfL.BMEventsType).CUSTOM]),
        [(0, $cXQfL.BMEventsType).WEB_VITALS]: $b7d0a7f7e241bd85$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $cXQfL.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("20DN1", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $81831026bbec4183$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $81831026bbec4183$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $81831026bbec4183$export$d53d07b6034c4560);
class $81831026bbec4183$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($81831026bbec4183$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($81831026bbec4183$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $81831026bbec4183$export$4ab84f6f04f6566d = new $81831026bbec4183$var$UFOLogger();
const $81831026bbec4183$export$b4958caff08a0960 = (...args)=>{
    $81831026bbec4183$export$4ab84f6f04f6566d.log(...args);
};
const $81831026bbec4183$export$d53d07b6034c4560 = (...args)=>{
    $81831026bbec4183$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("dSWrv", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $a045af695fe2350f$export$15e172712955e18f);
const $a045af695fe2350f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("9mSCV", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $87565dca5a1c43c0$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $87565dca5a1c43c0$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $87565dca5a1c43c0$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $87565dca5a1c43c0$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $87565dca5a1c43c0$export$7c957416596ca127);

var $20DN1 = parcelRequire("20DN1");

var $h1AcD = parcelRequire("h1AcD");
const $87565dca5a1c43c0$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $87565dca5a1c43c0$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $87565dca5a1c43c0$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $87565dca5a1c43c0$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $20DN1.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $87565dca5a1c43c0$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $h1AcD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $87565dca5a1c43c0$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $h1AcD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $87565dca5a1c43c0$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $h1AcD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("h1AcD", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $370991380abdb813$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $370991380abdb813$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $370991380abdb813$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $370991380abdb813$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $370991380abdb813$export$837e0f79a8056912);
var $370991380abdb813$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $370991380abdb813$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $370991380abdb813$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $370991380abdb813$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $370991380abdb813$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $370991380abdb813$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $370991380abdb813$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $370991380abdb813$export$9f2bf58999404c75 = 'fmp';
const $370991380abdb813$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("kHJa7", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d9e13de5808ce019$export$13e680397ec8f3eb);

var $dSWrv = parcelRequire("dSWrv");
class $d9e13de5808ce019$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $dSWrv.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d9e13de5808ce019$export$13e680397ec8f3eb = new $d9e13de5808ce019$var$VisibilityChangeObserver();

});

parcelRegister("2lxLk", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $236d15fc84985f9f$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $236d15fc84985f9f$export$cc26007c03242fff);
var $236d15fc84985f9f$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $236d15fc84985f9f$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("8tVkR", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $e10c5ae62e49a3ec$export$edb879ae55bb9be3);

var $2lxLk = parcelRequire("2lxLk");
var $kHJa7 = parcelRequire("kHJa7");

var $9mSCV = parcelRequire("9mSCV");

var $20DN1 = parcelRequire("20DN1");

var $h1AcD = parcelRequire("h1AcD");


var $hSmZA = parcelRequire("hSmZA");

var $gCnTT = parcelRequire("gCnTT");

var $3Ii6r = parcelRequire("3Ii6r");

var $iL7bc = parcelRequire("iL7bc");

var $8ggaw = parcelRequire("8ggaw");

var $11Cfx = parcelRequire("11Cfx");

var $aTIpH = parcelRequire("aTIpH");

var $efXKk = parcelRequire("efXKk");

var $hkvRY = parcelRequire("hkvRY");

var $93CbQ = parcelRequire("93CbQ");

var $2lv2y = parcelRequire("2lv2y");

var $hrnST = parcelRequire("hrnST");

var $1DyeY = parcelRequire("1DyeY");

var $3iZ6K = parcelRequire("3iZ6K");

var $enIpl = parcelRequire("enIpl");

var $qz0k6 = parcelRequire("qz0k6");

var $Zg3DO = parcelRequire("Zg3DO");
const $e10c5ae62e49a3ec$var$UNKNOWN_VALUE = 'unknown';
const $e10c5ae62e49a3ec$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $e10c5ae62e49a3ec$var$UNKNOWN_VALUE,
    id: $e10c5ae62e49a3ec$var$UNKNOWN_VALUE,
    uuid: $e10c5ae62e49a3ec$var$UNKNOWN_VALUE,
    state: {
        id: $e10c5ae62e49a3ec$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $2lxLk.ExperienceTypes).Experience,
    category: $e10c5ae62e49a3ec$var$UNKNOWN_VALUE,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $h1AcD.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $e10c5ae62e49a3ec$var$Publisher {
    publish(data) {
        const payloadStart = (0, $Zg3DO.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $20DN1.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$e10c5ae62e49a3ec$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $c2146f5087eba60f$export$93809551debf385f) || $e10c5ae62e49a3ec$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $efXKk.eventBrowserPlugin)(),
                    ...(0, $hkvRY.eventCpusPlugin)(),
                    ...(0, $2lv2y.eventMemoryPlugin)(),
                    ...(0, $hrnST.eventNetworkPlugin)(),
                    ...(0, $11Cfx.appFramework)(this.app),
                    ...(0, $aTIpH.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $hSmZA.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $iL7bc.pageVisibleState)(supportedData),
                    ...(0, $qz0k6.isInitialPageLoad)(supportedData) && (0, $3iZ6K.ssrSuccess)(this.ssr),
                    ...(0, $qz0k6.isInitialPageLoad)(supportedData) && (0, $1DyeY.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $93CbQ.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: this.getPerformanceMetrics(supportedData),
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $Zg3DO.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $20DN1.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $9mSCV.getGlobalEventStream)() instanceof (0, $gCnTT.UFOGlobalEventStream))) {
            const eventStream = new (0, $gCnTT.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $h1AcD.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $9mSCV.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $kHJa7.visibilityChangeObserver).start();
        (0, $8ggaw.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $3Ii6r.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $e10c5ae62e49a3ec$var$UNKNOWN_VALUE;
        this.hostname = (0, $Zg3DO.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $hSmZA.TenantType).RealUser;
        this.app = {
            version: {
                web: $e10c5ae62e49a3ec$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $enIpl.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $e10c5ae62e49a3ec$export$edb879ae55bb9be3 = new $e10c5ae62e49a3ec$var$Publisher();

});
// temp solution until a proper versioning
const $c2146f5087eba60f$export$93809551debf385f = '0.1.7';

parcelRegister("hSmZA", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $139b5c949978d445$export$92a757ac1398962f);

var $139b5c949978d445$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("gCnTT", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $fab5684a9e7df21f$export$faf4c91b80fc830e);

var $20DN1 = parcelRequire("20DN1");

var $h1AcD = parcelRequire("h1AcD");
class $fab5684a9e7df21f$export$faf4c91b80fc830e {
    push(event) {
        (0, $20DN1.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $h1AcD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $h1AcD.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $h1AcD.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $h1AcD.SUBSCRIBE_ALL]) this.subscribers[0, $h1AcD.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $20DN1.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("3Ii6r", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $43a87f4104b742dd$export$738d24377baf6a5e);

var $2lxLk = parcelRequire("2lxLk");

var $h1AcD = parcelRequire("h1AcD");

var $qz0k6 = parcelRequire("qz0k6");

var $3z4re = parcelRequire("3z4re");

var $61qNE = parcelRequire("61qNE");

var $67ah7 = parcelRequire("67ah7");

var $gv4sg = parcelRequire("gv4sg");
const $43a87f4104b742dd$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $43a87f4104b742dd$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $43a87f4104b742dd$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $43a87f4104b742dd$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $2lxLk.ExperiencePerformanceTypes).PageLoad:
            case (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$43a87f4104b742dd$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$43a87f4104b742dd$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $2lxLk.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$43a87f4104b742dd$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$43a87f4104b742dd$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $2lxLk.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$43a87f4104b742dd$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $43a87f4104b742dd$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $h1AcD.FMP_MARK))?.time || (0, $qz0k6.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$43a87f4104b742dd$var$LoadMetricKeys.tti]: Math.round(tti),
        [$43a87f4104b742dd$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$43a87f4104b742dd$var$getHistogram(data, performanceConfig)
    };
};
const $43a87f4104b742dd$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $h1AcD.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$43a87f4104b742dd$var$InlineResultMetricKeys.result]: Math.round(result),
        [$43a87f4104b742dd$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$43a87f4104b742dd$var$getHistogram(data, performanceConfig)
    };
};
const $43a87f4104b742dd$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$43a87f4104b742dd$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$43a87f4104b742dd$var$getHistogram(data, performanceConfig)
    };
};
const $43a87f4104b742dd$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $2lxLk.ExperiencePerformanceTypes).PageLoad:
        case (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad:
            return $43a87f4104b742dd$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $2lxLk.ExperiencePerformanceTypes).InlineResult:
            return $43a87f4104b742dd$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $2lxLk.ExperiencePerformanceTypes).Custom:
            return $43a87f4104b742dd$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $43a87f4104b742dd$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$43a87f4104b742dd$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $gv4sg.resourceTimings)(data, resourceConfig),
        ...(0, $67ah7.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $61qNE.appTimings)(data, ssr),
        ...(0, $qz0k6.isInitialPageLoad)(data) ? (0, $3z4re.navigationMetrics)() : null
    };
};

});
parcelRegister("qz0k6", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $dc9a4fdaabd894a8$export$7167d96e9881d500);

var $2lxLk = parcelRequire("2lxLk");
const $dc9a4fdaabd894a8$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $2lxLk.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("3z4re", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $f28b6d72302412fb$export$b88d990436be0f8a);
const $f28b6d72302412fb$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("61qNE", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $e92ad06237a5bc44$export$e952f50a4f2d02da);

var $2lxLk = parcelRequire("2lxLk");

var $qz0k6 = parcelRequire("qz0k6");

var $i0xIl = parcelRequire("i0xIl");

var $3Tnih = parcelRequire("3Tnih");
const $e92ad06237a5bc44$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $2lxLk.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $i0xIl.customTimings)(data);
    const ssr = (0, $qz0k6.isInitialPageLoad)(data) ? (0, $3Tnih.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("i0xIl", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $c648f0a201226e98$export$6126f85083a72c6e);
const $c648f0a201226e98$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $c648f0a201226e98$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $c648f0a201226e98$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("3Tnih", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $c1c8fe70a7b01c70$export$130f411261a599c5);

const $c1c8fe70a7b01c70$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $c1c8fe70a7b01c70$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $c1c8fe70a7b01c70$var$SSR_PREFIX = 'ssr';
const $c1c8fe70a7b01c70$var$mapKey = (key)=>{
    if (key === 'total') return $c1c8fe70a7b01c70$var$SSR_PREFIX;
    return `${$c1c8fe70a7b01c70$var$SSR_PREFIX}${0, $779a7211687b8cb3$export$b98e411ae80c806f}${key}`;
};
const $c1c8fe70a7b01c70$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($c1c8fe70a7b01c70$var$filterEntry(entry[1])) acc[$c1c8fe70a7b01c70$var$mapKey(entry[0])] = $c1c8fe70a7b01c70$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $779a7211687b8cb3$export$b98e411ae80c806f = '/';



parcelRegister("67ah7", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $4487431771a58881$export$1a2bb347935fc536);

var $Zg3DO = parcelRequire("Zg3DO");
const $4487431771a58881$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $Zg3DO.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("Zg3DO", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $e4f7b7712e5022db$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $e4f7b7712e5022db$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $e4f7b7712e5022db$export$74560fd4e61fd440);
const $e4f7b7712e5022db$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $e4f7b7712e5022db$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $e4f7b7712e5022db$export$9aa44f85591248d9() || {};
    return performance;
};
const $e4f7b7712e5022db$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $e4f7b7712e5022db$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("gv4sg", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $8ab1893309cbbbf6$export$81a7d52441a06b50);

var $Zg3DO = parcelRequire("Zg3DO");

var $8ggaw = parcelRequire("8ggaw");
const $8ab1893309cbbbf6$var$cacheableTypes = [
    'script',
    'link'
];
const $8ab1893309cbbbf6$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $8ab1893309cbbbf6$var$CACHE_NETWORK = 'network';
const $8ab1893309cbbbf6$var$CACHE_MEMORY = 'memory';
const $8ab1893309cbbbf6$var$CACHE_DISK = 'disk';
const $8ab1893309cbbbf6$var$calculateTransferType = (type, duration, size)=>{
    if (!$8ab1893309cbbbf6$var$cacheableTypes.includes(type)) return $8ab1893309cbbbf6$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $8ab1893309cbbbf6$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $8ab1893309cbbbf6$var$CACHE_DISK;
    if (size === undefined) return null;
    return $8ab1893309cbbbf6$var$CACHE_NETWORK;
};
const $8ab1893309cbbbf6$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$8ab1893309cbbbf6$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $Zg3DO.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $8ab1893309cbbbf6$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $8ab1893309cbbbf6$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $8ab1893309cbbbf6$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $8ab1893309cbbbf6$var$getNetworkData = (item, eventStart, hasTimingHeaders = $8ab1893309cbbbf6$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$8ab1893309cbbbf6$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($8ab1893309cbbbf6$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $8ab1893309cbbbf6$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$8ab1893309cbbbf6$var$getSizeObject(transferSize)
        };
        if (transferType !== $8ab1893309cbbbf6$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$8ab1893309cbbbf6$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$8ab1893309cbbbf6$var$getSizeObject(transferSize)
    };
};
const $8ab1893309cbbbf6$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $Zg3DO.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $8ggaw.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $8ab1893309cbbbf6$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $8ab1893309cbbbf6$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$8ab1893309cbbbf6$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("8ggaw", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $7112fd971b90c185$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $7112fd971b90c185$export$9eebb59359c2e9e5);
// @flow strict-local

var $20DN1 = parcelRequire("20DN1");

var $Zg3DO = parcelRequire("Zg3DO");
const $7112fd971b90c185$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $Zg3DO.getPerformanceObject)(), PerformanceObserver1 = (0, $Zg3DO.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($7112fd971b90c185$export$bea963256235a63e.observer) {
            (0, $20DN1.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $7112fd971b90c185$export$bea963256235a63e.timings = resources.map((resource)=>$7112fd971b90c185$export$bea963256235a63e.transformResource(resource));
        $7112fd971b90c185$export$bea963256235a63e.observer = new PerformanceObserver1($7112fd971b90c185$export$bea963256235a63e.addTimings);
        $7112fd971b90c185$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($7112fd971b90c185$export$bea963256235a63e.observer) {
            $7112fd971b90c185$export$bea963256235a63e.observer.disconnect();
            $7112fd971b90c185$export$bea963256235a63e.observer = null;
        }
        $7112fd971b90c185$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$7112fd971b90c185$export$bea963256235a63e.transformResource(entry));
        const overflow = $7112fd971b90c185$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $7112fd971b90c185$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $7112fd971b90c185$export$bea963256235a63e.maxSize;
            $7112fd971b90c185$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $7112fd971b90c185$export$bea963256235a63e.timings.push(...entries);
    }
};
const $7112fd971b90c185$export$9eebb59359c2e9e5 = (startTime, performance = (0, $Zg3DO.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$7112fd971b90c185$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $7112fd971b90c185$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("iL7bc", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $d951ae70b4f7d0c7$export$723b4c298aca63af);

var $h1AcD = parcelRequire("h1AcD");
const $d951ae70b4f7d0c7$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $h1AcD.PageVisibleState).HIDDEN : (0, $h1AcD.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("11Cfx", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $61921642778ce03a$export$e34e4529b979f74c);
const $61921642778ce03a$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("aTIpH", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $39236aa1d107f378$export$82ae485178b37419);
const $39236aa1d107f378$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("efXKk", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $ae6d0fd22e2b9a74$export$f435c2789ca334a7);

var $3nEAz = parcelRequire("3nEAz");

var $LFmXM = parcelRequire("LFmXM");

var $Zg3DO = parcelRequire("Zg3DO");
const $ae6d0fd22e2b9a74$export$f435c2789ca334a7 = (0, $LFmXM.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser((0, $Zg3DO.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("hkvRY", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $d061c33a3d8afc7f$export$db7649b8854107ad);

var $LFmXM = parcelRequire("LFmXM");
const $d061c33a3d8afc7f$export$db7649b8854107ad = (0, $LFmXM.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("93CbQ", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $47f2bbdc17cee477$export$e62953d023125748);
const $47f2bbdc17cee477$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("2lv2y", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $d219a8422151f007$export$81efaf8414879a1a);

var $LFmXM = parcelRequire("LFmXM");
const $d219a8422151f007$export$81efaf8414879a1a = (0, $LFmXM.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("hrnST", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $45d2a5fbf3d62a00$export$ce1cf816dce1da56);
const $45d2a5fbf3d62a00$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("1DyeY", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $db3d4464d526d204$export$fdbea518c19dfa8);
const $db3d4464d526d204$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("3iZ6K", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $471b0a55a762f948$export$a3dc8251cf55b2e0);
const $471b0a55a762f948$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("enIpl", function(module, exports) {
$parcel$export(module.exports, "Route", () => $dbdf0cef9540acf6$export$e7b0ac011bb776c6);
const $dbdf0cef9540acf6$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $c9cb1b3997607889$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $c9cb1b3997607889$export$f005e2e9f707cb5f = 'commercial';
const $c9cb1b3997607889$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $c9cb1b3997607889$export$a739cd5aac835909 = 'stg';
const $c9cb1b3997607889$export$42dd0cdd351a4a9 = 'prod';
const $c9cb1b3997607889$export$404582bc18fe4d9e = 'dev';

const $54dbbe6dc88f8bd2$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';
const $315aedf92e50a945$export$a310f85340477585 = 'assets';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $71feb0ebe2f021d7$export$cf090d5281b5ae06 = 10000;
const $71feb0ebe2f021d7$export$8575e30be0feb909 = 30000;

const $10b5883439ef237e$export$3288b14b6745c572 = 204;
const $10b5883439ef237e$export$c09e7ea0fc79f34f = 409;
const $10b5883439ef237e$export$974c37534b0191b1 = 503;

const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';

const $c2258fadc4095860$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


$parcel$global.rlb("7imUH")
//# sourceMappingURL=shared~commons~atlassian~ar.1c725fc0.js.map
